import { render, staticRenderFns } from "./ShowVideo.vue?vue&type=template&id=23f58f80&scoped=true"
import script from "./ShowVideo.vue?vue&type=script&lang=js"
export * from "./ShowVideo.vue?vue&type=script&lang=js"
import style0 from "./ShowVideo.vue?vue&type=style&index=0&id=23f58f80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f58f80",
  null
  
)

export default component.exports